import * as React from 'react';
import * as _ from 'lodash';
import { css, StyleSheet } from 'aphrodite';
import { combineStyles, media, mixins } from 'consumer-components';

import { AvoidWidowText } from 'shared-react';
import * as IconButtonStyles from 'login-stylesheets/IconButton';

const styles = StyleSheet.create({
  button: combineStyles(IconButtonStyles.button, mixins.padding(0, 20, 0, 0), {
    height: 125,
    [media.mobileMedium]: {
      height: 105,
      marginBottom: 12,
      paddingRight: 12,
    },
  }),
  buttonSelected: IconButtonStyles.buttonSelected,
  textWrapper: combineStyles(IconButtonStyles.textWrapper, {
    width: '70%',
    [media.mobileMedium]: {
      marginLeft: 8,
      width: '73%',
    },
  }),
  buttonText: IconButtonStyles.buttonText,
  buttonSubText: IconButtonStyles.buttonSubText,
});

export interface LargeIconButtonBase {
  iconComponent: React.ComponentType;
  buttonId: string;
  text: string;
  subText?: string | string[];
  selected?: boolean;
}

export interface LargeIconButtonConfig extends LargeIconButtonBase {
  value: any;
}

interface LargeIconButtonProps extends LargeIconButtonBase {
  onClick(Event): void;
}

export default class LargeIconButton extends React.PureComponent<LargeIconButtonProps> {
  render() {
    const { buttonId, iconComponent, text, subText, selected, onClick } = this.props;
    const Icon = iconComponent;
    const subTextArray = _.isArray(subText) ? subText : _.compact([subText]);

    return (
      <button id={buttonId} className={css([styles.button, selected && styles.buttonSelected])} onClick={onClick}>
        <Icon />
        <div className={css(styles.textWrapper)}>
          <h2 className={css(styles.buttonText)}>
            <AvoidWidowText text={text} />
          </h2>
          {_.map(subTextArray, (buttonSubText, i) => (
            <p key={i} className={css(styles.buttonSubText)}>
              {buttonSubText}
            </p>
          ))}
        </div>
      </button>
    );
  }
}
